<template>
<div id="mainpage" :style="pageStyle">
  <Notification :message="notificationtext" :duration="30" v-if="shownotification"  class="notification" :style="{ backgroundColor: notificationColor, color:notificationtextColor}" />
  <CountdownTimer  class="countdowntimer"   :timeruitype="timerui"  :initialMinutes="totalcountdownmins"  :autoStart="true"  v-if="showcountdowntimer"/>
  <div id="settingpage" v-if="showsetting">
    <!-- <div id="settingpage" > -->
    <button @click="()=>{this.showsetting=false}" style="float:right;background:none;border:none"><closebutton/></button>
   
    <setting/>
  </div>


  <div class="memberpage" v-if="showmember">
    <!-- <div id="settingpage" > -->
    <button @click="()=>{this.showmember=false}" style="float:right;background:none;border:none"><closebutton/></button>
    
    <member />
  </div>
 <div id="addbox" class="addsolobox" v-if="showadd">
   <SoloTaskbox/>
 </div>

 <div class="quicktools" >
  <div>
    <!-- <rocketicon v-if="false" @click="showprojectsprogress=!showprojectsprogress"/> -->
    <badgeicon v-if="isVipUser" @click="showheatmap=!showheatmap"/>
  </div>
  <div>
    <!-- <rocketicon v-if="false" @click="showprojectsprogress=!showprojectsprogress"/> -->
    <tableicon v-if="isVipUser" @click="showtreemap=!showtreemap"/>
  </div>
  <div>
    <!-- <rocketicon v-if="false" @click="showprojectsprogress=!showprojectsprogress"/> -->
    <rocketicon v-if="isVipUser" @click="showprojectsprogress=!showprojectsprogress"/>
  </div>
  <div>
    <clockicon  @click="toggleClock" />
  </div>
 <div id = "chaticonfixed">
  <chaticon  @click="showchatfunc"/>
 </div>
</div>

 <div id="chatbox" class="chatbox dragzone" v-if="showchat" v-draggable >
    <div class="chatbox-header">
      
      <span>atomTask nice to meet you💗</span>
      <button @click="showchatfunc">x</button>
      
    </div>
    
    <div class="chat-content">
      <Chat />
    </div>
    <div class="resize-handle"></div>
  </div>

  <div id="chatbox" class="chatbox badgezone dragzone" v-if="showbadgezone" v-draggable>
    <div class="chatbox-header">
      
      <span>badges💗</span>
      <button @click="showbadgezonefunc">x</button>
      
    </div>
    
    <div class="chat-content">
      <badgeshowzone />
    </div>
    <div class="resize-handle"></div>
  </div>

  <div id="mainheader" :style="headerstyle">
    
    <div class="logozone">
      <img
          class="imageforlogin"
          style="width:40px;height:40px;margin-left: 0px;margin-top: 5px;"
          src="https://images-1255367272.cos.ap-chengdu.myqcloud.com/orangenew.png"
          alt="orange"
         
        />   
        <!-- <img id="fruitshow" :src="fruiticon"   :class="{ fruitshow: fruitdropdisabled }" style="width:12px;height:12px"   /> -->
        <!-- 只需要控制这里的icon就行了 -->
        <!-- <img id="fruitshow" :src="svgsource"   :class="{ fruitshow: fruitdropdisabled }" style="width:12px;height:12px"   /> -->
      
        <img id="fruitshow" :src="svgsource"  v-if="fruitshowvisual"  :class="{ fruitshow: fruitdropdisabled }" style="width:12px;height:12px"   />
        <!-- <object type="image/svg+xml" id="fruitshow" :data="svgsource" :class="{ fruitshow: fruitdropdisabled }" style="width:12px;height:12px"></object> -->
        <!-- <a class="titleheader">doledole<span>.Life</span></a>
      <span class="logoviceinfo">Think different</span>  -->
      <div id="amazing"  :class="{ amazingday: amazingdayable }" >Niubility day👍{{ '👍'.repeat(amazingcount-1) }}</div>
    </div>
    <timerCount v-if="timerCountshow"/>
    <div id="shortcutzone">

      <h3 class="documentheader" style="margin-right: 10px;">
      <a>
   
   
   
        <a-select
         ref = "selectdom"
        id="searchframe"
        show-search
        allowClear 
        @focus="focusclear"
        v-model:value="selectvalueinsearch"
        @clear="clearsearch"   
      placeholder="search you want (also with ctrl+f) "
      style="width: 400px"
    >
  
    <a-select-option v-for="(item) in options" :key="item"
     :value="item.value" 
    @click="goitem(item.id,item.type,item.value,item)">
 
    <div><a :class="'searcheditem_' + item.type">{{item.type}}</a> {{item.value}} </div>
  </a-select-option>
  
      </a-select>
      <!-- <a-tooltip title="search you want" color="red" mouseEnterDelay="2">
      <searchicon/></a-tooltip> -->
    </a></h3>

    <h3 class="documentheader addtaskheader"><a  style="margin-right: 10px;" @click="showaddbox">
    
      <plusblock/>
  
    </a></h3>


    <h3 class="tagheader documentheader">
      <a   href='/tagmanage' style="margin-right: 10px;">
      <taglogo/>
      </a>
    </h3>



    <h3 class="documentheader dairybookheader">
      <a   href='/pridebook' style="margin-right: 10px;">
      <pridebookicon/>
      </a>
    </h3>

    <h3 class="goalheader documentheader">
      <a   href='/goalmanage' style="margin-right: 10px;">
  
      <goalicon   />
      
    </a></h3>




  
    <h3 class="goalheader documentheader"><a   style="margin-right: 10px;">
  
      <chaticon  @click="showchatfunc"/>
      
    </a></h3>

    <h3 class="goalheader documentheader"><a   style="margin-right: 10px;">
  <badgeicon  @click="showbadgezonefunc"></badgeicon>
  
</a></h3>
<h3 style="margin-right: 10px;" class="documentheader"><a @click="openFullscreen" >
     
     <focusicon/>
</a></h3>
    <!-- <h3 style="margin-right: 10px;" v-if="showthis" class="documentheader"><a @click="()=>{this.$router.push('/docweb')}"> -->
      <h3 style="margin-right: 10px;"  class="documentheader"><a href="/docs" target="_blank">
      <manualicon title="帮助"/>
</a></h3>

<h3 style="margin-right: 10px;" v-if="showthis" class="documentheader"><a @click="()=>{this.$router.push('/travel')}" class="traveltext">travel</a></h3>
     <!-- <h3 class="documentheader"><a href="/docweb" class="logoutinheader">Manual</a></h3> -->
    
    <a-dropdown>
      <h3 id="logoutheader"><usericon/></h3>
    <!-- <button class="ant-dropdown-link" @click.prevent>check</button> -->
    <template #overlay>
      <a-menu>
        <a-menu-item v-if="showthis">
          <div>Profile</div> 
        </a-menu-item>
        <a-menu-item >
          <!-- <div  @click="()=>{this.$router.push('/setting')}" >Setting</div> -->
          <!-- <div class="indownmenu" @click="()=>{this.showmember=true}" ><div>{{ $t('premium') }}</div><img :src="vipicon" style="width:18px;margin-left:20px"/></div> -->
       <div class="indownmenu" @click="()=>{this.$router.push('/premium')}" ><div>{{ $t('premium') }}</div><img :src="vipicon" style="width:18px;margin-left:20px"/></div>
 
        </a-menu-item> 

        <a-menu-item>
          <!-- <div  @click="()=>{this.$router.push('/setting')}" >Setting</div> -->
          <div class="indownmenu" @click="()=>{this.showsetting=true}" ><div>{{ $t('setting') }}</div><settingicon style="width:18px;margin-left:20px"/></div>
        </a-menu-item> 
        <a-menu-item >
        
          <div class="indownmenu" @click="()=>{this.$router.push('/')}" ><div>{{ $t('logout') }}</div><logouticon style="width:18px;margin-left:20px"/></div>
        
        </a-menu-item>
        <!-- <a-menu-item>
          <button data-composite-hover="" data-command="" type="button" id=":r1h:" role="menuitem" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-hidden="true"><g fill="none" fill-rule="evenodd"><path fill="currentColor" fill-rule="nonzero" d="M15 18v-1h2.44c.66 0 .86-.04 1.07-.15a.82.82 0 00.34-.35c.11-.2.15-.4.15-1.06v-4.88c0-.66-.04-.86-.15-1.07a.82.82 0 00-.35-.34c-.2-.11-.4-.15-1.06-.15H6.56c-.66 0-.86.04-1.07.15a.82.82 0 00-.34.34C5.04 9.7 5 9.9 5 10.56v4.88c0 .66.04.86.15 1.07a.82.82 0 00.34.34c.21.11.41.15 1.07.15H9v1H6.56c-.89 0-1.21-.1-1.54-.27a1.82 1.82 0 01-.75-.75c-.18-.33-.27-.65-.27-1.54v-4.88c0-.89.1-1.21.27-1.54.17-.32.43-.58.75-.75.33-.18.65-.27 1.54-.27h10.88c.89 0 1.21.1 1.54.27.32.17.58.43.75.75.18.33.27.65.27 1.54v4.88c0 .89-.1 1.21-.27 1.54a1.8 1.8 0 01-.75.75c-.33.18-.65.27-1.54.27H15z"></path><path stroke="currentColor" d="M15.5 13.5h-7v3.94c0 .73.05 1.01.2 1.3.14.24.32.42.56.55.29.16.57.21 1.3.21h2.88c.73 0 1.01-.05 1.3-.2.24-.14.42-.32.55-.56.16-.29.21-.57.21-1.3V13.5z"></path><path fill="currentColor" fill-rule="nonzero" d="M17 7h-1v-.44c0-.66-.04-.86-.15-1.07a.82.82 0 00-.34-.34C15.3 5.04 15.1 5 14.44 5H9.56c-.66 0-.86.04-1.07.15a.82.82 0 00-.34.34C8.04 5.7 8 5.9 8 6.57V7H7v-.44c0-.89.1-1.21.27-1.54.17-.32.43-.58.75-.75.33-.18.65-.27 1.54-.27h4.88c.89 0 1.21.1 1.54.27.32.17.58.43.75.75.18.33.27.65.27 1.54V7z"></path><path fill="currentColor" d="M16 11h1v1h-1z"></path></g></svg><span class="user_menu_label">Print</span><div class="XTtNSGL1M3piX7+WL3O2sA== _2a3b75a1 _509a57b4 e5a9206f _50ba6b6b"><kbd class="Yf-wJadrSX6XVF7XudGdeg=="><kbd class="l-x-sujkj-BdLQOUK+onwA== xivNdw8VtfMO4dChMoK+4g== a83bd4e0 _266d6623 _2a3b75a1">Ctrl</kbd><kbd class="l-x-sujkj-BdLQOUK+onwA== xivNdw8VtfMO4dChMoK+4g== a83bd4e0 _266d6623 _2a3b75a1">P</kbd></kbd></div></button>
        </a-menu-item> -->
        <a-menu-item>
          <div class="indownmenu" @click="()=>{this.$router.push('/version')}" >
          {{ $t('makewith') }} ❤️ {{ version }}
          </div>  
        </a-menu-item>    
      </a-menu>
    </template>
  </a-dropdown>
   </div>
   
  </div>





  <div id="mainboday">
  <div id='shorttime'>
  
    <!-- <a href="/timer"> timer</a>
    <a href="/goalmanage"> goal</a> -->
    <!-- <Taskszone/> -->
    <TaskTreeContainer showheader=true   id="treetaskzone"></TaskTreeContainer>
   
    <!-- <plusblock  @click="()=>{showadd=!showadd}" /> -->
    
    </div>
  <div id='review'>
    
    <Review v-if="true" />
    <!-- <Goaltree/> -->
    <Goaltreerecursion/>
    <div class="tdlab animationLab" v-if="showbaloon">
    <!-- <ThreeExperimentVue v-if="false"/> -->
    <apple3dVue v-if="false"/>
    <External3DModelVue :onAnimationEnd="handleAnimationEnd" />
    </div>

    <div class="tdlab animationLab" v-if="showdance">
    <!-- <ThreeExperimentVue v-if="false"/> -->
 
    <danceanimation :onAnimationEnd="handleAnimationEnd" />
    </div>


    <div class="tdlab animationLab" v-if="showdonut">
    <!-- <ThreeExperimentVue v-if="false"/> -->
    <donut3dmodel :onAnimationEnd="handleAnimationEnd" />
    </div>


    <div class="tdlab animationLab" v-if="showrocket">
    <!-- <ThreeExperimentVue v-if="false"/> -->
    <rocketmodel :onAnimationEnd="handleAnimationEnd" />
    </div>

    <div class="tdlab animationLab" v-if="showguitar">
    <!-- <ThreeExperimentVue v-if="false"/> -->
    <guitarmodel :onAnimationEnd="handleAnimationEnd" />
    </div>
    <div class="tdlab animationLab" v-if="showwood">
    <!-- <ThreeExperimentVue v-if="false"/> -->
    <woodcrack :onAnimationEnd="handleAnimationEnd" />
    </div>
    </div>

    <div class="dragzone" v-draggable>
      <heatmap v-if="showheatmap" />
    </div>

    <div class="dragzone" v-draggable>
      <pomodoroUI v-if="showpomodoro" />
    </div>

    <div class="dragzone" v-draggable>
      <projectsprogressbarUI v-if="showprojectsprogress" />
    </div>

    


    <div class="dragzone" v-draggable>
      <treemap v-if="showtreemap" />
    </div>


    <div class="dragzone" v-draggable>
      <geyanUI message="积极 健康 思不同 解决难题 与他人合作  不断突破 " v-if="showgeyan" />
    </div>

    <div class="dragzone" v-if="showclock" v-draggable>
      <clock/>
    </div>
  </div>  
</div>
</template>

<script>

// import Taskszone from './taskszone.vue'
// import { mapGetters } from 'vuex';


import axios from 'axios';
import emitter from "../eventbus.js"; 
import Review from './review.vue'
import Chat from "./chat.vue"
import configure_options from '../configure'
import heatmap from "./reviews/heatmap.vue"
import treemap from "./reviews/treechart.vue"
import geyanUI from "./reviews/sentence.vue"
import pomodoroUI from "./timer/pomodoro.vue"
import projectsprogressbarUI from "./projects/projectsprogressbar.vue"
// import Goaltree from './goaltree.vue'
import Goaltreerecursion from './goaltreerecursion.vue'
import countdownTimer from './countdowntimer.vue';
import TaskTreeContainer from './treecontainer.vue'
import SoloTaskbox from "./soloaddtaskbox.vue"
import  tableicon from "../svg/tableicon.vue"
import  goalicon from "../svg/goalicon.vue"
import  plusblock from "../svg/plusblock.vue"
import  manualicon from "../svg/manualicon.vue"
import  chaticon from "../svg/chaticon.vue"
import  clockicon from "../svg/clockicon.vue"
import  rocketicon from "../svg/rocketicon.vue"
import  badgeicon from "../svg/badgeicon.vue"
import  logouticon from "../svg/logouticon.vue"
import  settingicon from "../svg/settingicon.vue"
import  badgeshowzone from "./badgeshowzone.vue"
import  focusicon from "../svg/focusicon.vue"
import  taglogo from "../svg/taglogo.vue"
import  usericon from "../svg/usericon.vue"
import  pridebookicon from "../svg/pridebookicon.vue"
import setting from "./setting.vue";
import member from "./member.vue";
import timerCount from "./timer.vue";
import closebutton from  '../svg/close.vue'
import websocket from '../channel/websocket';
import Notification from './notification.vue';
import { computed } from 'vue';

import clock from './timer/clock.vue';
import '../css/fruit.css'
import '../css/tag.css'



// import 'quasar/dist/quasar.css'
// import  searchicon from "../svg/searchicon.vue"
import { getCurrentInstance } from 'vue'
import { defineComponent,ref } from 'vue';
import { onBeforeUnmount,onMounted } from 'vue';
import { useStore } from 'vuex';
import apple3dVue from "./threedcomponents/apple3d.vue";
import External3DModelVue from "./threedcomponents/balloon3DModel.vue";
import donut3dmodel from "./threedcomponents/donut3dmodel.vue";
import Danceanimation from './threedcomponents/danceanimation.vue';
import woodcrack from "./threedcomponents/woodcrack.vue"
import rocketmodel from "./threedcomponents/rocketanimation.vue"
import guitarmodel from "./threedcomponents/guitaranimation.vue"
// import ThreeExperimentVue from "./threedcomponents/ThreeExperiment.vue"
// import { useQuasar } from 'quasar'
export default defineComponent( 

{
  name: 'reference',
  props: {
    msg: String
  },
  data() {
      return {
      //  items:[],
    vipicon: require('../assets/vip.svg'),
    tagicon: require('../assets/tag.svg'),
    notebookicon: require('../assets/notebook.svg'),
    fruiticon: require('../assets/orangefruit.svg'),
    basketballicon: require('../assets/basketball.svg'),
    showsetting:false,
    showmember:false,
    showcountdowntimer:false,

    showthis:false,
    targetDate: new Date('2024-12-31T23:59:59'), // 设置目标日期,
    searchautofocus:false,
    selectvalueinsearch:"",
    version:configure_options["version"],
    options:[],
    showadd:false,
    showchat:false,
    showbadgezone:false,
    
     totalcountdownmins:0,
     timerui:"timer",
     headerstyle:{},
    // showanimation:"noshowanimation",
    selectedtype:"no",
    }

  },

  // created(){
  //   emitter.on("refreshtasks",msg=>{
  //     alert(1)
  //     if(msg=="finishedtoday"){
  //       this.warnDisabled()
  //       alert(1)
  //     }
  //       console.log("HomeContent接收到得About发送得数据了：",msg);
       
  //   });
  // },
  mounted(){
 
    
    var _this = this
           var env =  configure_options["env"]
          
       this.getUserinfo()
       
        console.log(configure_options["app_setting"][env])
        if(env=="dev"||env=="devnginx"){
          _this.showthis = true
        }
      
        websocket.registerCallback('text', this.handleTextMessage);
        emitter.on("refresh_searchcontent",msg=>{
    //   alert("检查是否被盗用")
    


          // console.log("检测这里的接收到信息部分")
          // console.log(msg)
          _this.options = msg
      })


      emitter.on("showbaloon",msg=>{
          console.log(msg)
      
       
      })

      emitter.on("offbaloon",msg=>{
          console.log(msg)
          
          _this.showbaloon = false
      })



      
      emitter.on("showwood",msg=>{
        console.log(msg)
     
          _this.showwood = true
      
       
      })

      emitter.on("offwood",msg=>{
          console.log(msg)
          
          _this.showwood = false
      })



      emitter.on("showpomodoro",msg=>{
        console.log(msg)
     
          _this.showpomodoro = true
      
       
      })

      emitter.on("offpomodoro",msg=>{
          console.log(msg)
          
          _this.showpomodoro = false
      })


     

      emitter.on("showtreemap",msg=>{
        console.log(msg)
          // alert(1)
          _this.showtreemap = true
      
       
      })

      emitter.on("offtreemap",msg=>{
          console.log(msg)
          
          _this.showtreemap = false
      })

   
      emitter.on("showguitar",msg=>{
        console.log(msg)
     
          _this.showguitar = true
      
       
      })

      emitter.on("offguitar",msg=>{
          console.log(msg)
          
          _this.showguitar = false
      })
      emitter.on("showrocket",msg=>{
        console.log(msg)
     
          _this.showrocket = true
      
       
      })

      emitter.on("offrocket",msg=>{
          console.log(msg)
          
          _this.showrocket = false
      })


      emitter.on("showdance",msg=>{
          console.log(msg)
        _this.showdance= true
      })
      emitter.on("offdance",msg=>{
          console.log(msg)
          _this.showdance = false
      })
      emitter.on("showdonut",msg=>{
          console.log(msg)
        _this.showdonut= true
      })
      emitter.on("offdonut",msg=>{
          console.log(msg)
          _this.showdonut = false
      })
      emitter.on("showclock",msg=>{
          console.log(msg)
          
          _this.showclock = true
      })
      emitter.on("offclock",msg=>{
          console.log(msg)
          
          _this.showclock = false
      })
      emitter.on("showcountdowntimer",msg=>{
    //   alert("检查是否被盗用")
      console.log(msg)
      // alert(msg)
      this.totalcountdownmins = msg["tt"]
      this.timerui = msg["ui"]
     
      this.showcountdowntimer = true
      })

      emitter.on("shownotification",msg=>{
      // alert("检查是否激活")
      console.log(msg)
      // alert(msg)
      // this.totalcountdownmins = msg
      this.shownotification = true
    
    })

    emitter.on("showheatmap",msg=>{
      // alert("检查是否激活")
      console.log(msg)
      // alert(msg)
      // this.totalcountdownmins = msg
      _this.showheatmap = true
    
    })

    emitter.on("offheatmap",msg=>{
      // alert("检查是否激活")
      console.log(msg)
      // alert(msg)
      // this.totalcountdownmins = msg
      _this.showheatmap = false
    
    })




    emitter.on("showprojectsprogress",msg=>{
      // alert("检查是否激活")
      console.log(msg)
      
      // this.totalcountdownmins = msg
      _this.showprojectsprogress = true
    
    })

    emitter.on("offprojectsprogress",msg=>{
      // alert("检查是否激活")
      console.log(msg)
      // alert(msg)
      // this.totalcountdownmins = msg
      _this.showprojectsprogress = false
    
    })



      emitter.on("closetimer",msg=>{
        console.log(msg)
      this.showcountdowntimer = false
      
    })
      emitter.on("closenotification",msg=>{
        console.log(msg)
      
      this.shownotification = false
      })

      emitter.on("refreshtasksfinished",(msg) =>{
      // alert(1)
      // alert(msg)
      console.log(msg)

    // 检查是否为amazingday
    //  var amazing =  msg.amazingday
    // 检查该元素是否存在


      if(msg.type=="finishedtoday"){
        _this.dropfunction(msg.data)
       var command = msg.command
       if(this.isVipUser){
        // alert(command)
        if(command){
          _this[command] = true;  
        }
      
        }
      }
        console.log("HomeContent接收到得About发送得数据了：",msg);
       
    });


    emitter.on("amazingsignal",(msg) =>{
      // alert(msg)
      console.log(msg)
      if(msg.type=="amazingsignal"){
     
        if(msg.amazingday==true){
          if(_this.amazingcount!=undefined){
            _this.amazingcount = msg.amazingcount
          }
          
          _this.amazingdayable = true
        }
       
      }
        // console.log("amazingsignal",msg);
       
    });

    emitter.on("getuserinfo",(msg) =>{
      // alert(msg)
      console.log(msg)
   this.getUserinfo()
        // console.log("amazingsignal",msg);
       
    });

    emitter.on("timercountsignal",(msg) =>{
      // alert(msg)
    
      console.log(msg)
   
     
        if(msg=="on"){
          // alert("on")
          _this.timerCountshow = true
        }
         if(msg=="off"){
          // alert("off")
          _this.timerCountshow = false

         }
        
       
   
        // console.log("amazingsignal",msg);
       
    });



      emitter.on("trunoffsoloaddbox",async (msg)=> {
       
          // _this.options = msg
          if(msg=="fromsoloaddbox"){
            // alert("检查是否被盗用")
              console.log(1)
              _this.showadd = false
          }
         
          // _this.warnDisabled()
    
      })
   


      window.addEventListener("keydown", this.KeyDown, true);

  

  },
  methods:{
   
    // 监听键盘事件
    KeyDown(e){
      
      if(e.ctrlKey&&e.keyCode===70){
        
        e.preventDefault();
        console.log('Ctrl+c');
        // alert("检测")
               // alert(taskid)
        // document.getElementById(`searchframe`).scrollIntoView({behavior: 'auto',
        // block: 'center',
        // inline: 'center'})
        // document.getElementById(`searchframe`).click()
        // this.searchautofocus = true;
      //  这里直接回调
        this.$refs.selectdom.focus()
        
      }

      if(e.metaKey&&e.keyCode===70){
        
        e.preventDefault();
        console.log('Command +f');
        // alert("检测")
               // alert(taskid)
        // document.getElementById(`searchframe`).scrollIntoView({behavior: 'auto',
        // block: 'center',
        // inline: 'center'})
        // document.getElementById(`searchframe`).click()
        // this.searchautofocus = true;
      //  这里直接回调
        this.$refs.selectdom.focus()
        
      }


    },
    
    showchatfunc1(){
    // alert(1)
   this.showchat = !this.showchat

      
      this.$nextTick(() => {
        this.makeChatboxDraggable();
      });
    
    },

    makeChatboxDraggable() {
  const chatbox = this.$el.querySelector("#chatbox");
  const chatboxHeader = chatbox.querySelector(".chatbox-header");

  let isDragging = false;
  let startX, startY;
  chatbox.addEventListener("scroll", (e) => {
    e.stopPropagation();  // 阻止滚动事件冒泡
    e.preventDefault();   // 阻止default的滚动行为
  });
  chatboxHeader.addEventListener("mousedown", (e) => {
    e.stopPropagation();
    // 如果点击的是按钮，不执行拖动操作
    if (e.target.tagName === 'BUTTON') {
      return;
    }
    
    isDragging = true;
    startX = e.clientX - chatbox.offsetLeft;
    startY = e.clientY - chatbox.offsetTop;
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  });

  const onMouseMove = (e) => {
    e.stopPropagation();
    if (isDragging) {
      chatbox.style.left = `${e.clientX - startX}px`;
      chatbox.style.top = `${e.clientY - startY}px`;
    }
  };

  const onMouseUp = (e) => {
    e.stopPropagation();
    isDragging = false;
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  };
    },

   
    showaddbox1(){
      this.showadd = true;
      // document.getElementById("mainpage").style.opacity = 0.1
      // document.getElementById("addbox").style.opacity =0.8
    },

    showchatfunc() {
      this.showchat = !this.showchat;
      if (this.showchat) {
        this.$nextTick(() => {
          this.makeChatboxDraggable();
          this.makeChatboxResizable();
        });
      }
    },

    showbadgezonefunc() {
   
      this.showbadgezone = !this.showbadgezone;
      if (this.showbadgezone ) {
        this.$nextTick(() => {
          this.makeChatboxDraggable();
          this.makeChatboxResizable();
        });
      }
    },

  
    makeChatboxResizable() {
      const chatbox = this.$el.querySelector("#chatbox");
      const resizeHandle = chatbox.querySelector(".resize-handle");

      let isResizing = false;
      let startWidth, startHeight, startX, startY;

      resizeHandle.addEventListener("mousedown", (e) => {
        e.stopPropagation();
        isResizing = true;
        startX = e.clientX;
        startY = e.clientY;
        startWidth = parseInt(document.defaultView.getComputedStyle(chatbox).width, 10);
        startHeight = parseInt(document.defaultView.getComputedStyle(chatbox).height, 10);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      });

      const onMouseMove = (e) => {
        e.stopPropagation();
        if (isResizing) {
          chatbox.style.width = `${startWidth + e.clientX - startX}px`;
          chatbox.style.height = `${startHeight + e.clientY - startY}px`;
        }
      };

      const onMouseUp = (e) => {
        e.stopPropagation();
        isResizing = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };
    },
    showaddbox() {
      this.showadd = true;
      // document.getElementById("mainpage").style.opacity = 0.1
      // document.getElementById("addbox").style.opacity =0.8
    },
  

    alert(message) {
      this.showmember = false;
                    alert(message)
                    alert(this.showmember)
                },

    openFullscreen() {
      if (document.fullscreenElement) {
    document
      .exitFullscreen()
      .then(() => console.log("Document Exited from Full screen mode"))
      .catch((err) => console.error(err));
  } else {
    document.documentElement.requestFullscreen();
  }
},


focusclear(){
  const elements = document.getElementsByClassName("tasktext");
 
  // Set the background color of the elements to red
  for (const element of elements) {
  console.log(element)
    //TODO 掌握这里的initial的原因
    // element.style.backgroundColor = "initial";
}
},


clearsearch(){
  
  if(this.selectedtype=="tag"){
    // alert(this.selectvalueinsearch)
    const elements = document.getElementsByClassName(this.selectvalueinsearch);
  this.selectedtype =  "none"
  // Set the background color of the elements to red
  for (const element of elements) {
    element.style.backgroundColor = "initial";
}
  }
},


   async  goitem(id,type,value="zero",item){
    this.focusclear()


    console.log("检测这里传进来的item部分")
    console.log(item)


    const scrollDiv = document.getElementById('review');
    const screenHeight = window.innerHeight/2;



    if(type=="task"){

     // 获取要滚动到的目标元素
const targetElement = document.getElementById(`block_${id}`);
// 计算目标元素相对于包含滚动的 div 的偏移量

const targetRect = targetElement.getBoundingClientRect();

const offset = targetRect.top + scrollDiv.scrollTop-screenHeight;

// 滚动到目标元素的位置
scrollDiv.scrollTop = offset;


    // document.getElementById(`block_${id}`).scrollIntoView({behavior: 'auto',
    // block: 'center',
    // inline: 'center'})


    
    // document.getElementById(`tasktext_${id}`).style.background="red"
    // // this.sleep(10000)
    // await this.sleep(1000);
    // // alert("test")
    // document.getElementById(`tasktext_${id}`).style.background='none'


    const taskTextElement = document.getElementById(`tasktext_${id}`);
        taskTextElement.classList.add("highlight-shake");

        await this.sleep(1000);
        taskTextElement.classList.remove("highlight-shake");

    }

    if(type=="goal"){


      const targetElement = document.getElementById(`goaltext_${id}`);
// 计算目标元素相对于包含滚动的 div 的偏移量

const targetRect = targetElement.getBoundingClientRect();

const offset = targetRect.top + scrollDiv.scrollTop-screenHeight;
scrollDiv.scrollTop = offset;
// // 滚动到目标元素的位置
// scrollDiv.scrollTop = offset;
//     // alert(taskid)
//     document.getElementById(`goaltext_${id}`).scrollIntoView({behavior: 'auto',
//     block: 'center',
//     inline: 'center'})

    document.getElementById(`goaltext_${id}`).style.background="yellow"
    // this.sleep(10000)
    await this.sleep(1000);
    // alert("test")
    document.getElementById(`goaltext_${id}`).style.background='none'

}


if(type=="project"){

  
  const targetElement =document.getElementById(`projecttext_${id}`);
  
// 计算目标元素相对于包含滚动的 div 的偏移量

const targetRect = targetElement.getBoundingClientRect();

const offset = targetRect.top + scrollDiv.scrollTop-screenHeight;
scrollDiv.scrollTop = offset;
  // document.getElementById(`projecttext_${id}`).scrollIntoView({behavior: 'auto',
  // block: 'center',
  // inline: 'center'})

  document.getElementById(`projecttext_${id}`).style.background="blue"
  // this.sleep(10000)
  await this.sleep(1000);
  // alert("test")
  document.getElementById(`projecttext_${id}`).style.background='none'

}



if(type=="tag"){
// alert("tag here")

const elements = document.getElementsByClassName(value);
this.selectedtype =  "tag"
// Set the background color of the elements to red
for (const element of elements) {
  element.style.backgroundColor = "pink";
}
// alert(taskid)


}

  
  }
    ,
    sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
    }

  },
  components:{
    // Taskszone,
    Review,
    clock,
    geyanUI,
    clockicon,
    pomodoroUI,
    rocketmodel,
    guitarmodel,
    woodcrack,
    treemap,
    projectsprogressbarUI,
    CountdownTimer: countdownTimer,
    // ThreeExperimentVue,
    External3DModelVue,
    donut3dmodel,
    apple3dVue,
    Chat,
    member,
    timerCount,
    plusblock,
    focusicon,
    chaticon,
    taglogo,
    goalicon,
    tableicon,
    rocketicon,
    closebutton,
    manualicon,
    logouticon,
    pridebookicon,
    usericon,
    settingicon,
    badgeicon,
    heatmap,
    badgeshowzone,
    // searchicon,
    // Goaltree,
    Goaltreerecursion,
    TaskTreeContainer,
    setting,
    SoloTaskbox,
    Notification,
    Danceanimation,

  },
  setup(props,context) {
    const store = useStore();


    const isFullscreen = computed(() => store.state.isFullscreen);

// 切换全屏状态
const toggleFullscreen = () => {
  store.dispatch('toggleFullscreen');
  alert(isFullscreen.value)
  if(isFullscreen.value){
    document.documentElement.requestFullscreen();
  }else{
 
   document
      .exitFullscreen()
      .then(() => console.log("Document Exited from Full screen mode"))
      .catch((err) => console.error(err));
  }

  // if (document.fullscreenElement) {
  //   document
  //     .exitFullscreen()
  //     .then(() => console.log("Document Exited from Full screen mode"))
  //     .catch((err) => console.error(err));
  // } else {
  //   document.documentElement.requestFullscreen();
  // }
};

    const loadFont = (fontname,fontUrl) => {
      if (fontUrl === 'default') {
        // 如果是默认字体，不加载任何自定义字体
        return;
      }
      // alert("check if loadfont ")

      // 生成字体规则
      var fontName = fontname;
      fontName="customfont"
      const fontFace = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}') format('woff2'),
               url('${fontUrl}') format('woff'),
               url('${fontUrl}') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `;

      // 创建并注入 <style> 标签
      const style = document.createElement('style');
      style.appendChild(document.createTextNode(fontFace));
      document.head.appendChild(style);
       pageStyle.value= {
        fontFamily: fontName,
      };
      console.log("❤️🧡💛💚💙💜")
      console.log(pageStyle)
      // 应用字体到页面
      document.body.style.fontFamily = fontName;
    };
    onMounted(() => {
      console.log("we start")
    // store.dispatch('fetchUser');
    emitter.on("showgeyan",msg=>{
        console.log(msg)
          // alert(1)
          showgeyan.value = true
      
          store.dispatch('setGeyan', true);
      })

      emitter.on("offgeyan",msg=>{
          console.log(msg)
          
          showgeyan.value = false
          store.dispatch('setGeyan', false);
      })



 
    });
    const connectWebSocket = () => {
      const env = configure_options["env"];
      let wsUrl = "wss://www.cosmosatom.cc/v1/ws"; // 默认开发地址
      if (env === "devnginx") {
        wsUrl = "ws://127.0.0.1:8081/v1/ws";
        
      }

      // 假设有一个权限验证方法 isUserAuthorized
      if (isUserAuthorized()) {
        websocket.connect(wsUrl); // 建立 WebSocket 连接
        console.log("WebSocket connection established.");
      } else {
        console.log("User not authorized. WebSocket connection not established.");
      }
    };

    const isUserAuthorized = () => {
      // 在这里添加你的权限鉴定逻辑
      // 例如，检查用户是否已登录或权限是否满足条件
      return true;  // 示例：根据实际逻辑返回 true 或 false
    };

    const isVipUser = computed(() => {
      
  return store.getters.userLevel === 'vip';
});
  const { proxy } = getCurrentInstance()

 console.log(props,context)
 const fruiticon = require('../assets/orangefruit.svg')
 const basketballicon = require('../assets/basketball.svg')
 
 var iconmap = {
   orange:fruiticon,
   basketball:basketballicon
 }
 const fruitshowdisabled = ref(true)
 const svgsource = ref('');
 const notificationtext =ref("")
 var  showbaloon=ref(false)
 var showdance =ref(false)
 var showheatmap = ref(false)
 var showtreemap = ref(false)
 var showdonut = ref(false)
 var showguitar=ref(false);
 var showpomodoro=ref(false);
 var showwood = ref(false)
 var showrocket = ref(false)
 const shownotification = ref(false)
 const showgeyan = computed(() => store.getters.showgeyan);

 const showclock = computed(() => store.state.showClock);

// 触发 Vuex action 来修改 showClock 状态
const toggleClock = () => {
  store.dispatch('toggleClock');
};
 var showprojectsprogress = ref(false)
 const notificationbackgroundColor = ref('#ffffff');
 const notificationtextColor = ref('black');
 const selectedfont= ref("default");
 var fruitshowvisual = ref(false);
 var pageStyle = ref({})
// animation start
function updatePageStyle() {
      // 更新整个页面的样式
      pageStyle.value = {
        // fontFamily: "customFont"
        fontFamily: this.selectedfont === "default" ? "inherit" : this.selectedfont
      };
      console.log("💚")
      console.log(pageStyle)
      // alert("updatepagestyle check if work")
      // this.loadFont("https://userimages-1255367272.cos.ap-shanghai.myqcloud.com/YanShiQiuHongKai-2.ttf");
    }

function handleTextMessage(message) {
      console.log("Received text message:", message);
      // alert(1)
      
     var mode1 = false
     var keyword = message.keyword
     var messagetext =  message[keyword]
     var backgroundcolor = message.style.backgroundcolor
     var textcolor = message.style.textcolor
   if(mode1){


      proxy.$q.notify({
        type: 'info',  // 通知类型，'positive' 会影响通知的默认外观
        progress: true,
  message: messagetext,
  caption: '困难挑战',
  position: 'bottom-right',  // 通知在页面的显示位置
  timeout: 10000,  // 通知自动消失的时间 (以毫秒为单位)
  // color:"brand",
  classes:"pornlike-notify",
  // actions: [
  //           { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
  //         ],
  icon: 'info'  // 使用的图标，可以使用 Material Icons 的图标
      });
   }else{
     shownotification.value = true
     notificationtext.value = messagetext
     notificationbackgroundColor.value=backgroundcolor
    //  这里服务端可能有bug我需要注意
    console.log(textcolor)
     notificationtextColor.value = textcolor
   }
   
    }
function dropSomething(svgdatafromserver) {
  
  console.log(fruiticon)
  console.log(iconmap)
  console.log(svgdatafromserver)
 var svgdata=svgdatafromserver

 const svgBlob = new Blob([svgdata], { type: 'image/svg+xml' });
// 将 svgBase64 绑定到组件的 svgsource 属性上
svgsource.value =  URL.createObjectURL(svgBlob);
  fruitshowdisabled.value = true
  fruitshowvisual.value= true
  setTimeout(() => {
    fruitshowdisabled.value = false
 //注意这的时间
 fruitshowvisual.value = false
  }, 10500)

  
  // alert("call this")
}

function  getUserinfo() {
      const env = configure_options["env"];
      const serverhost = configure_options["app_setting"][env]["serverhost"];

      axios.get(`${serverhost}/v1/userinfo`)
        .then(response => {
          var data = response.data
          var userlevel = data["userlevel"]
           
            if(userlevel=="vip"){
              this.connectWebSocket()
              this.headerstyle={
        background:"#e11858"
      }
            }
          const setting = response.data.setting || "{}";

          // 设置字体
          this.selectedfont = (() => { 
            try { 
              return setting.font || "default"; 
            } catch (e) { 
              return "default"; 
            } 
          })();
          // alert(this.selectedfont)
          // 如果字体的key在对应的字典中载入对应的字体url
          const settingsObj = setting;
       
          const userUploadsFonts = settingsObj.useruploadsfonts || {};
          this.updatePageStyle();
          if (this.selectedfont in userUploadsFonts) {
                this.loadFont(this.selectedfont,userUploadsFonts[this.selectedfont]); // 假设 loadfont 是一个已定义的方法
                // alert("需要更新")
            }
       
        })
        .catch(error => {
          console.log("获取字体信息失败：", error);
          this.selectedfont = "default"; // 如果请求失败，设置为default字体
          this.updatePageStyle();
        });
    }
 
   

   function handleAnimationEnd(command) {
      // 使用一个对象来映射 command 到相应的动画显示状态
      const animationMap = {
        "baloon": () => showbaloon.value = false,
        "donut": () => showdonut.value = false,
        "dance": () => showdance.value = false,
        "wood": () => showwood.value = false,
        "rocket": () => showrocket.value = false,
        "guitar": () => showguitar.value = false,
      };
      
      // 如果 command 存在于映射中，就调用相应的隐藏动画方法
      if (animationMap[command]) {
        animationMap[command]();  // 执行隐藏对应动画的方法
      }
    }
  

   onBeforeUnmount(() => {
      websocket.close();  // 组件卸载前，断开 WebSocket 连接
      console.log("WebSocket connection closed.");
    });
  

    return {
      handleAnimationEnd,
      getUserinfo,
      isFullscreen,
      toggleFullscreen,
      isVipUser,
      showwood,
      showdance,
      showguitar,
      showpomodoro,
      showtreemap,
      showbaloon,
      showheatmap,
      showclock,
      toggleClock,
      showrocket,
      showgeyan,
      showprojectsprogress,
      showdonut,
      currentgoal:ref({}),
      fruitdropdisabled: fruitshowdisabled,
      connectWebSocket,
      amazingdayable:ref(false),
      timerCountshow:ref(false),
      amazingcount:ref(1),
      dropfunction: dropSomething,
      notificationColor: notificationbackgroundColor,
      notificationtextColor,
      selectedfont,
      // modifygoal,
      // svgsource:ref(''),
      items:ref([]),
      svgsource, 
      pageStyle,// 用于存储整个页面的样式
      loadFont,
      updatePageStyle,
      shownotification ,
      notificationtext,
      
      fruitshowvisual,handleTextMessage,
      
   
    };
  },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.dragzone{
  // position: absolute;
  top:20%;
  left:3%;
}


.tdlab{
  position:fixed;
  right: 0px;
  top:0px;
  width:50vw;
  height: 100vh;
}
/* #treetaskzone{
   margin-left:50px 
} */

.traveltext{
  font-size: 20px;
  color:"black";
}

:fullscreen, ::backdrop {
    background-color: rgb(243, 239, 16);
}

#mainpage{
  display: flex;
  flex-direction:column;
  
}
#logoutheader{
  margin-top:10px;
  margin-right:10px;
}

.documentheader{
  margin-top:10px;
}

.goalheader{
  color:white;
  margin-top:10px;
  /* margin-right: 23px; */
}


.indownmenu{
  display: flex;
  flex-direction: row;
  /* justify-content: flex-end; */
 align-items: left;
}


#mainheader{
  display: flex;
  justify-content: space-between;
  /* justify-content: center; */
  height: 50px;
  background-color:var(--maincolor);
  color :white;
  
  text-align: left;
}

#shortcutzone{
  display:flex;
  justify-content: space-between;
  align-items: center;

}


.logozone{
  max-height: 40px;
  max-width: 40vw;
  display: flex;
  flex-direction: row;
  margin-left:12px;
  position: relative;
   

  img:hover{
  transform: scale(0.9);
  // transform: scale;
  // translate: 100% 0;
  
}



.titleheader{
  
  /* color: white; */
  margin-bottom: 0px;
  font-size: 30px;
  color:black;
  line-height:30px;
  // text-decoration: underline;
  border-bottom: solid 0.1px black;
  // padding-bottom: solid 0.1px black;
  margin-right:10px;
  /* font-family:fantasy; */

}
.logoviceinfo{
  color:black;
  font-size:8px;
}
}


.logoutinheader{
  color:white;
  margin-top:23px;
  margin-right: 23px;
}


.searcheditem_project{
  /* border:1px solid red; */
  color:slateblue;
}

.searcheditem_goal{
  /* border:1px solid red; */
  color:red;
}

.searcheditem_tag{
  color:rgb(14, 165, 8);
}

.logoutinheader:hover{
  color:red;

}


#settingpage{
  position:fixed;
  z-index:1;
  top:10%;
  left:22%;
  right:22%;
  height:500px;
  background-color:#d9e9d1
}


.chatbox {
  position: absolute;
  top: 0; /* 视窗顶部 */
  left: 0; /* 视窗左侧 */
  z-index: 9999; /* 使其位于视窗最顶层 */
  margin: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #fff; /* 确保背景颜色为不透明 */
}
.chatbox-header {
  background-color: #f1f1f1;
  cursor: move;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  position: sticky; /* 使header部分保持在顶部 */
  top: 0;
  z-index: 3; /* 确保header在滚动内容之上 */
  display: flex;
  justify-content: space-between; /* 使内容左右分布 */
  align-items: center; /* 垂直居中 */
  
}
.chat-content {
  overflow-y: auto;
  max-height: calc(100% - 40px); /* Adjust height to make space for resize handle */
}

.resize-handle {
  width: 16px;
  height: 16px;
  background-color: #ccc;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: se-resize;
}


.chatbox-header button {
  background-color: transparent; /* 背景透明 */
  border: none; /* 无边框 */
  color: inherit; /* 保持字体颜色 */
  font-size: 16px; /* 设置字体大小 */
  cursor: default; /* 鼠标悬停时显示为指针 */
  padding: 0; /* 移除内边距 */
}

.chatbox-header button:focus {
  outline: none; /* 移除聚焦时的外边框 */
}
.addsolobox{
  position:fixed;
  z-index:1;
  top:10%;
  left:33%;
  right:33%;
  max-width: 500px;
  height:500px;
  background-color:white;
  opacity: 1;
  border:1px solid rgb(209, 200, 200);
  border-radius: 2px;
  /* box-shadow:  2px 2px rgb(209, 200, 200); */
}


span{
  color: red;
}
#mainboday{
  display: flex;
}


#review{
    /* position: absolute; */
    width: 50%;
    overflow-y: scroll;
    top:2%;
    left:50%;
    right: 20px;
    height:100vh;
    margin-bottom: 1px;
    background: rgb(222, 235, 251);
    
}
#shorttime{
    margin-left:40px ;
    /* width:500px; */
    width:50%;
    //深色模式
    // background: var(--darkcolor);
    // color:var(--darkfont--color);
    
}

//深色模式
#shorttime--dark,#review--dark{
    // margin-left:40px ;
    /* width:500px; */
    width:50%;
    //深色模式
    background: var(--darkcolor);
    color:var(--darkfont--color);
    
}



$border-color: rgba(0, 0, 0, 0.2);
$shadow-color-light: rgba(0, 0, 0, 0.1);
$shadow-color-dark: rgba(0, 0, 0, 0.3);
$background-gradient: linear-gradient(145deg, #f1f1f1, #dcdcdc);

.quicktools {
  position: fixed;
  padding: 1px; // 增加一些内边距，使按钮不至于太拥挤
  bottom: 10px;
  left: 10px; // 提供一些边距，使它离页面边缘有一定的距离
  z-index: 2;
  border: 1px solid $border-color; // 更细的黑色边框，增加现代感
  border-radius: 12px; // 更圆滑的圆角
  background: $background-gradient; // 渐变背景
  box-shadow: 4px 4px 12px $shadow-color-light, -4px -4px 12px rgba(255, 255, 255, 0.3); // 3D悬浮效果
  display: flex;
  flex-direction: column; // 使用flex布局来排列工具
  gap: 10px; // 工具之间的间隔
  padding: 10px; // 增加内边距

  // 子元素的样式
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out; // 过渡效果

    &:hover {
      transform: scale(1.1); // 悬停时略微放大
      cursor: pointer; // 悬停时显示手指光标
    }
  }

  // 针对#chaticonfixed的样式
  #chaticonfixed {
    // background-color: #fff;
    border-radius: 50%; // 圆形背景
    padding: 8px;
    box-shadow: 2px 2px 8px $shadow-color-light; // 给按钮加阴影

    &:hover {
      box-shadow: 4px 4px 12px $shadow-color-dark; // 悬停时加大阴影
      transform: scale(1.1); // 悬停时放大
    }
  }
}

// 图标样式
.clockicon, .chaticon {
  width: 30px;
  height: 30px;
  color: #333; // 图标的颜色
  font-size: 18px; // 图标的大小
}

.badgezone{
  width: 20vw;
  max-height: 70vh;
  background:white;
}

.memberpage{
  background:rgb(147, 154, 155);
  position:fixed;
  width:45em;
  opacity: 1;
  top:2%;
  left:50%;
  z-index: 222;
  height:40em;
  overflow-y:auto;
}
.addtaskicon{
  text-align: left;
 
  
  margin-left:45px;
  margin-top:5px;
  span{
    background: red;
    color:white;
    // padding: 1px;
    border:1px solid red;
    height: 16px;
    width: 16px;
    
    border-radius: 50%;
  }
}

#amazing {
  display: none; /* 初始状态隐藏 */
}

.countdowntimer{
position: absolute;
right:0%;
max-width: 40vw;
}

.notification{
position: absolute;
right:40%;
bottom: 0%;
color: black;
max-width: 22vw;
z-index: 9999;

}



#amazing.amazingday{
  display: block; /* 或其他合适的显示方式 */
  background: rgb(7, 11, 211);
  padding-left:3px;
  padding-right: 3px;
  font-family:"goodfont";
  min-width:70px;
  margin-top:6px;
  text-align: center;
  font-size: large;
}
.amazingday {
    animation: moveRight 3s 4 alternate; /* 使用动画效果 */
    white-space: nowrap; /* 防止文字换行 */
  }

  @keyframes moveRight {
    0% {
      transform: translateX(0); /* 初始位置，不做位移 */
    }
    90% {
      transform: translateX(40vw); /* 在 X 轴上移动 100 像素 */
    }
    100% {
      transform: translateX(40vw); /* 在 X 轴上移动 100 像素 */
    }
  }



:root { --linear-in: linear(0, 1); --linear-out: linear(0, 1); --linear-in-out: linear(0, 1); --power0-in: linear(0, 1); --power0-out: linear(0, 1); --power0-in-out: linear(0, 1); --quad-in: linear( 0, 0.0039, 0.0156, 0.0352, 0.0625, 0.0977, 0.1407, 0.1914, 0.2499, 0.3164, 0.3906 62.5%, 0.5625, 0.7656, 1 ); --quad-out: linear( 0, 0.2342, 0.4374, 0.6093 37.49%, 0.6835, 0.7499, 0.8086, 0.8593, 0.9023, 0.9375, 0.9648, 0.9844, 0.9961, 1 ); --quad-in-out: linear( 0, 0.0027, 0.0106 7.29%, 0.0425, 0.0957, 0.1701 29.16%, 0.2477, 0.3401 41.23%, 0.5982 55.18%, 0.7044 61.56%, 0.7987, 0.875 75%, 0.9297, 0.9687, 0.9922, 1 ); --power1-in: linear( 0, 0.0039, 0.0156, 0.0352, 0.0625, 0.0977, 0.1407, 0.1914, 0.2499, 0.3164, 0.3906 62.5%, 0.5625, 0.7656, 1 ); --power1-out: linear( 0, 0.2342, 0.4374, 0.6093 37.49%, 0.6835, 0.7499, 0.8086, 0.8593, 0.9023, 0.9375, 0.9648, 0.9844, 0.9961, 1 ); --power1-in-out: linear( 0, 0.0027, 0.0106 7.29%, 0.0425, 0.0957, 0.1701 29.16%, 0.2477, 0.3401 41.23%, 0.5982 55.18%, 0.7044 61.56%, 0.7987, 0.875 75%, 0.9297, 0.9687, 0.9922, 1 ); --cubic-in: linear( 0, 0.0014 11.11%, 0.0071 19.24%, 0.0188 26.6%, 0.037 33.33%, 0.0634 39.87%, 0.0978 46.07%, 0.1407 52.02%, 0.1925 57.74%, 0.2559 63.49%, 0.3295 69.07%, 0.4135 74.5%, 0.5083 79.81%, 0.6141 85%, 0.7312 90.09%, 1 ); --cubic-out: linear( 0, 0.2688 9.91%, 0.3859 15%, 0.4917 20.19%, 0.5865 25.5%, 0.6705 30.93%, 0.7441 36.51%, 0.8075 42.26%, 0.8593 47.98%, 0.9022 53.93%, 0.9366 60.13%, 0.963 66.67%, 0.9812 73.4%, 0.9929 80.76%, 0.9986 88.89%, 1 ); --cubic-in-out: linear( 0, 0.0036 9.62%, 0.0185 16.66%, 0.0489 23.03%, 0.0962 28.86%, 0.1705 34.93%, 0.269 40.66%, 0.3867 45.89%, 0.5833 52.95%, 0.683 57.05%, 0.7829 62.14%, 0.8621 67.46%, 0.8991 70.68%, 0.9299 74.03%, 0.9545 77.52%, 0.9735 81.21%, 0.9865 85%, 0.9949 89.15%, 1 ); --power2-in: linear( 0, 0.0014 11.11%, 0.0071 19.24%, 0.0188 26.6%, 0.037 33.33%, 0.0634 39.87%, 0.0978 46.07%, 0.1407 52.02%, 0.1925 57.74%, 0.2559 63.49%, 0.3295 69.07%, 0.4135 74.5%, 0.5083 79.81%, 0.6141 85%, 0.7312 90.09%, 1 ); --power2-out: linear( 0, 0.2688 9.91%, 0.3859 15%, 0.4917 20.19%, 0.5865 25.5%, 0.6705 30.93%, 0.7441 36.51%, 0.8075 42.26%, 0.8593 47.98%, 0.9022 53.93%, 0.9366 60.13%, 0.963 66.67%, 0.9812 73.4%, 0.9929 80.76%, 0.9986 88.89%, 1 ); --power2-in-out: linear( 0, 0.0036 9.62%, 0.0185 16.66%, 0.0489 23.03%, 0.0962 28.86%, 0.1705 34.93%, 0.269 40.66%, 0.3867 45.89%, 0.5833 52.95%, 0.683 57.05%, 0.7829 62.14%, 0.8621 67.46%, 0.8991 70.68%, 0.9299 74.03%, 0.9545 77.52%, 0.9735 81.21%, 0.9865 85%, 0.9949 89.15%, 1 ); --quart-in: linear( 0, 0.0039 25%, 0.0117 32.89%, 0.0248 39.68%, 0.0457 46.22%, 0.0743 52.21%, 0.1113 57.77%, 0.1575 63%, 0.218 68.33%, 0.2901 73.39%, 0.3745 78.23%, 0.4718 82.88%, 0.5827 87.37%, 0.7074 91.71%, 0.8462 95.91%, 1 ); --quart-out: linear( 0, 0.1538 4.09%, 0.2926 8.29%, 0.4173 12.63%, 0.5282 17.12%, 0.6255 21.77%, 0.7099 26.61%, 0.782 31.67%, 0.8425 37%, 0.8887 42.23%, 0.9257 47.79%, 0.9543 53.78%, 0.9752 60.32%, 0.9883 67.11%, 0.9961 75%, 1 ); --quart-in-out: linear( 0, 0.0029 13.8%, 0.0184 21.9%, 0.0339 25.51%, 0.0551 28.81%, 0.0827 31.88%, 0.1168 34.76%, 0.1962 39.57%, 0.3005 44.02%, 0.4084 47.53%, 0.6242 53.45%, 0.7493 57.93%, 0.8495 62.97%, 0.8888 65.67%, 0.9213 68.51%, 0.9629 73.9%, 0.9876 80.16%, 0.998 87.5%, 1 ); --power3-in: linear( 0, 0.0039 25%, 0.0117 32.89%, 0.0248 39.68%, 0.0457 46.22%, 0.0743 52.21%, 0.1113 57.77%, 0.1575 63%, 0.218 68.33%, 0.2901 73.39%, 0.3745 78.23%, 0.4718 82.88%, 0.5827 87.37%, 0.7074 91.71%, 0.8462 95.91%, 1 ); --power3-out: linear( 0, 0.1538 4.09%, 0.2926 8.29%, 0.4173 12.63%, 0.5282 17.12%, 0.6255 21.77%, 0.7099 26.61%, 0.782 31.67%, 0.8425 37%, 0.8887 42.23%, 0.9257 47.79%, 0.9543 53.78%, 0.9752 60.32%, 0.9883 67.11%, 0.9961 75%, 1 ); --power3-in-out: linear( 0, 0.0029 13.8%, 0.0184 21.9%, 0.0339 25.51%, 0.0551 28.81%, 0.0827 31.88%, 0.1168 34.76%, 0.1962 39.57%, 0.3005 44.02%, 0.4084 47.53%, 0.6242 53.45%, 0.7493 57.93%, 0.8495 62.97%, 0.8888 65.67%, 0.9213 68.51%, 0.9629 73.9%, 0.9876 80.16%, 0.998 87.5%, 1 ); --quint-in: linear( 0, 0.0024 29.91%, 0.008 38.03%, 0.0179 44.72%, 0.035 51.16%, 0.0595 56.88%, 0.0922 62.08%, 0.1338 66.88%, 0.1914 71.85%, 0.262 76.5%, 0.3461 80.88%, 0.4447 85.04%, 0.5587 89.01%, 0.689 92.82%, 0.8359 96.48%, 1 ); --quint-out: linear( 0, 0.1641 3.52%, 0.311 7.18%, 0.4413 10.99%, 0.5553 14.96%, 0.6539 19.12%, 0.738 23.5%, 0.8086 28.15%, 0.8662 33.12%, 0.9078 37.92%, 0.9405 43.12%, 0.965 48.84%, 0.9821 55.28%, 0.992 61.97%, 0.9976 70.09%, 1 ); --quint-in-out: linear( 0, 0.0012 14.95%, 0.0089 22.36%, 0.0297 28.43%, 0.0668 33.43%, 0.0979 36.08%, 0.1363 38.55%, 0.2373 43.07%, 0.3675 47.01%, 0.5984 52.15%, 0.7121 55.23%, 0.8192 59.21%, 0.898 63.62%, 0.9297 66.23%, 0.9546 69.06%, 0.9733 72.17%, 0.9864 75.67%, 0.9982 83.73%, 1 ); --power4-in: linear( 0, 0.0024 29.91%, 0.008 38.03%, 0.0179 44.72%, 0.035 51.16%, 0.0595 56.88%, 0.0922 62.08%, 0.1338 66.88%, 0.1914 71.85%, 0.262 76.5%, 0.3461 80.88%, 0.4447 85.04%, 0.5587 89.01%, 0.689 92.82%, 0.8359 96.48%, 1 ); --power4-out: linear( 0, 0.1641 3.52%, 0.311 7.18%, 0.4413 10.99%, 0.5553 14.96%, 0.6539 19.12%, 0.738 23.5%, 0.8086 28.15%, 0.8662 33.12%, 0.9078 37.92%, 0.9405 43.12%, 0.965 48.84%, 0.9821 55.28%, 0.992 61.97%, 0.9976 70.09%, 1 ); --power4-in-out: linear( 0, 0.0012 14.95%, 0.0089 22.36%, 0.0297 28.43%, 0.0668 33.43%, 0.0979 36.08%, 0.1363 38.55%, 0.2373 43.07%, 0.3675 47.01%, 0.5984 52.15%, 0.7121 55.23%, 0.8192 59.21%, 0.898 63.62%, 0.9297 66.23%, 0.9546 69.06%, 0.9733 72.17%, 0.9864 75.67%, 0.9982 83.73%, 1 ); --strong-in: linear( 0, 0.0024 29.91%, 0.008 38.03%, 0.0179 44.72%, 0.035 51.16%, 0.0595 56.88%, 0.0922 62.08%, 0.1338 66.88%, 0.1914 71.85%, 0.262 76.5%, 0.3461 80.88%, 0.4447 85.04%, 0.5587 89.01%, 0.689 92.82%, 0.8359 96.48%, 1 ); --strong-out: linear( 0, 0.1641 3.52%, 0.311 7.18%, 0.4413 10.99%, 0.5553 14.96%, 0.6539 19.12%, 0.738 23.5%, 0.8086 28.15%, 0.8662 33.12%, 0.9078 37.92%, 0.9405 43.12%, 0.965 48.84%, 0.9821 55.28%, 0.992 61.97%, 0.9976 70.09%, 1 ); --strong-in-out: linear( 0, 0.0012 14.95%, 0.0089 22.36%, 0.0297 28.43%, 0.0668 33.43%, 0.0979 36.08%, 0.1363 38.55%, 0.2373 43.07%, 0.3675 47.01%, 0.5984 52.15%, 0.7121 55.23%, 0.8192 59.21%, 0.898 63.62%, 0.9297 66.23%, 0.9546 69.06%, 0.9733 72.17%, 0.9864 75.67%, 0.9982 83.73%, 1 ); --elastic-in: linear( 0, 0.0019 13.34%, -0.0056 27.76%, -0.0012 31.86%, 0.0147 39.29%, 0.0161 42.46%, 0.0039 46.74%, -0.0416 54.3%, -0.046 57.29%, -0.0357, -0.0122 61.67%, 0.1176 69.29%, 0.1302 70.79%, 0.1306 72.16%, 0.1088 74.09%, 0.059 75.99%, -0.0317 78.19%, -0.3151 83.8%, -0.3643 85.52%, -0.3726, -0.3705 87.06%, -0.3463, -0.2959 89.3%, -0.1144 91.51%, 0.7822 97.9%, 1 ); --elastic-out: linear( 0, 0.2178 2.1%, 1.1144 8.49%, 1.2959 10.7%, 1.3463 11.81%, 1.3705 12.94%, 1.3726, 1.3643 14.48%, 1.3151 16.2%, 1.0317 21.81%, 0.941 24.01%, 0.8912 25.91%, 0.8694 27.84%, 0.8698 29.21%, 0.8824 30.71%, 1.0122 38.33%, 1.0357, 1.046 42.71%, 1.0416 45.7%, 0.9961 53.26%, 0.9839 57.54%, 0.9853 60.71%, 1.0012 68.14%, 1.0056 72.24%, 0.9981 86.66%, 1 ); --elastic-in-out: linear( 0, 0.0009 8.51%, -0.0047 19.22%, 0.0016 22.39%, 0.023 27.81%, 0.0237 30.08%, 0.0144 31.81%, -0.0051 33.48%, -0.1116 39.25%, -0.1181 40.59%, -0.1058 41.79%, -0.0455, 0.0701 45.34%, 0.9702 55.19%, 1.0696 56.97%, 1.0987 57.88%, 1.1146 58.82%, 1.1181 59.83%, 1.1092 60.95%, 1.0057 66.48%, 0.986 68.14%, 0.9765 69.84%, 0.9769 72.16%, 0.9984 77.61%, 1.0047 80.79%, 0.9991 91.48%, 1 ); --bounce-in: linear( 0, 0.0117, 0.0156, 0.0117, 0, 0.0273, 0.0468, 0.0586, 0.0625, 0.0586, 0.0468, 0.0273, 0 27.27%, 0.1093, 0.1875 36.36%, 0.2148, 0.2343, 0.2461, 0.25, 0.2461, 0.2344, 0.2148 52.28%, 0.1875 54.55%, 0.1095, 0, 0.2341, 0.4375, 0.6092, 0.75, 0.8593, 0.9375 90.91%, 0.9648, 0.9843, 0.9961, 1 );
   --bounce-out: linear( 0, 0.0039, 0.0157, 0.0352, 0.0625 -9.09%, 0.1407, 0.25, 0.3908, 0.5625, 0.7654, 1, 0.8907, 0.8125 45.45%, 0.7852, 0.7657, 0.7539, 0.75, 0.7539, 0.7657, 0.7852, 0.8125 63.64%, 0.8905, 1 72.73%, 0.9727, 0.9532, 0.9414, 0.9375, 0.9414, 0.9531, 0.9726, 1, 0.9883, 0.9844, 0.9883, 1 ); 
   --bounce-in-out: linear( 0, 0.0078, 0, 0.0235, 0.0313, 0.0235, 0.0001 13.63%, 0.0549 15.92%, 0.0938, 0.1172, 0.125, 0.1172, 0.0939 27.26%, 0.0554 29.51%, 0.0003 31.82%, 0.2192, 0.3751 40.91%, 0.4332, 0.4734 45.8%, 0.4947 48.12%, 0.5027 51.35%, 0.5153 53.19%, 0.5437, 0.5868 57.58%, 0.6579, 0.7504 62.87%, 0.9999 68.19%, 0.9453, 0.9061, 0.8828, 0.875, 0.8828, 0.9063, 0.9451 84.08%, 0.9999 86.37%, 0.9765, 0.9688, 0.9765, 1, 0.9922, 1 ); --expo-in: linear( 0, 0.0085 31.26%, 0.0167 40.94%, 0.0289 48.86%, 0.0471 55.92%, 0.0717 61.99%, 0.1038 67.32%, 0.1443 72.07%, 0.1989 76.7%, 0.2659 80.89%, 0.3465 84.71%, 0.4419 88.22%, 0.554 91.48%, 0.6835 94.51%, 0.8316 97.34%, 1 ); --expo-out: linear( 0, 0.1684 2.66%, 0.3165 5.49%, 0.446 8.52%, 0.5581 11.78%, 0.6535 15.29%, 0.7341 19.11%, 0.8011 23.3%, 0.8557 27.93%, 0.8962 32.68%, 0.9283 38.01%, 0.9529 44.08%, 0.9711 51.14%, 0.9833 59.06%, 0.9915 68.74%, 1 ); --expo-in-out: linear( 0, 0.0053 17.18%, 0.0195 26.59%, 0.0326 30.31%, 0.0506 33.48%, 0.0744 36.25%, 0.1046 38.71%, 0.1798 42.62%, 0.2846 45.93%, 0.3991 48.37%, 0.6358 52.29%, 0.765 55.45%, 0.8622 59.3%, 0.8986 61.51%, 0.9279 63.97%, 0.9481 66.34%, 0.9641 69.01%, 0.9856 75.57%, 0.9957 84.37%, 1 ); --circ-in: linear( -0, 0.0048 9.8%, 0.0192 19.5%, 0.043 29.02%, 0.0761 38.26%, 0.1181 47.13%, 0.1685 55.56%, 0.227 63.44%, 0.2929 70.71%, 0.3656 77.3%, 0.4445 83.15%, 0.5285 88.19%, 0.6173 92.39%, 0.7099 95.7%, 0.805 98.08%, 0.9021 99.52%, 1 ); --circ-out: linear( 0, 0.0979 0.48%, 0.195 1.92%, 0.2901 4.3%, 0.3827 7.61%, 0.4715 11.81%, 0.5555 16.85%, 0.6344 22.7%, 0.7071 29.29%, 0.773 36.56%, 0.8315 44.44%, 0.8819 52.87%, 0.9239 61.74%, 0.957 70.98%, 0.9808 80.5%, 0.9952 90.2%, 1 ); --circ-in-out: linear( -0, 0.0033 5.75%, 0.0132 11.43%, 0.0296 16.95%, 0.0522 22.25%, 0.0808 27.25%, 0.1149 31.89%, 0.1542 36.11%, 0.1981 39.85%, 0.2779 44.79%, 0.3654 48.15%, 0.4422 49.66%, 0.5807 50.66%, 0.6769 53.24%, 0.7253 55.37%, 0.7714 58.01%, 0.8142 61.11%, 0.8536 64.65%, 0.9158 72.23%, 0.9619 80.87%, 0.9904 90.25%, 1 ); --sine-in: linear( 0, 0.0035, 0.0141 10.7%, 0.0318 16.09%, 0.0566 21.51%, 0.0885 26.98%, 0.1278 32.53%, 0.2288 43.93%, 0.3563 55.48%, 0.5171 67.92%, 0.7139 81.53%, 1 ); --sine-out: linear( 0, 0.2861 18.47%, 0.4829 32.08%, 0.6437 44.52%, 0.7712 56.07%, 0.8722 67.47%, 0.9115 73.02%, 0.9434 78.49%, 0.9682 83.91%, 0.9859 89.3%, 0.9965, 1 ); --sine-in-out: linear( 0, 0.007 5.35%, 0.0282 10.75%, 0.0638 16.26%, 0.1144 21.96%, 0.1833 28.16%, 0.2717 34.9%, 0.6868 62.19%, 0.775 68.54%, 0.8457 74.3%, 0.9141 81.07%, 0.9621 87.52%, 0.9905 93.8%, 1 ); --back-in: linear( 0, -0.0029 4.31%, -0.0119 9.02%, -0.0838 31.27%, -0.0956 36.64%, -0.1 41.45%, -0.0953 47.03%, -0.0792 52.25%, -0.0512 57.19%, -0.0111 61.92%, 0.0512 67.19%, 0.131 72.27%, 0.2284 77.18%, 0.3443 81.96%, 0.479 86.62%, 0.6329 91.17%, 0.8065 95.63%, 1 ); --back-out: linear( 0, 0.1935 4.37%, 0.3671 8.83%, 0.521 13.38%, 0.6557 18.04%, 0.7716 22.82%, 0.869 27.73%, 0.9488 32.81%, 1.0111 38.08%, 1.0512 42.81%, 1.0792 47.75%, 1.0953 52.97%, 1.1 58.55%, 1.0956 63.36%, 1.0838 68.73%, 1.0119 90.98%, 1.0029 95.69%, 1 ); --back-in-out: linear( 0, -0.0077 5.2%, -0.0452 16.98%, -0.0493 22.35%, -0.0418 25.57%, -0.0258 28.57%, -0.0007 31.42%, 0.0335 34.15%, 0.1242 39.03%, 0.2505 43.65%, 0.3844 47.35%, 0.656 53.68%, 0.81 58.37%, 0.9282 63.52%, 0.9719 66.23%, 1.0055 69.04%, 1.0255 71.4%, 1.0396 73.87%, 1.0477 76.48%, 1.05 79.27%, 1.0419 84.36%, 1.0059 95.49%, 1 ); }

:root {
  --ease: var(--bounce-out);
}







</style>
